import React from 'react';

const SharedRichTextToolbar = ({ 
  isActive = false, 
  onCommand,
  onAddTextbox,
  onDeleteTextbox,
  onAddPhotos,
  canDeleteTextbox = false,
  className = ""
}) => {
  const executeCommand = (command, value = null) => {
    if (!isActive) return;
    
    if (onCommand) {
      onCommand(command, value);
    }
  };

  const buttonClass = (baseClass = "") => `
    px-2 py-1 border border-gray-300 rounded text-sm font-medium transition-colors duration-200
    ${isActive 
      ? 'bg-white text-gray-700 hover:bg-gray-50 cursor-pointer' 
      : 'bg-gray-100 text-gray-400 cursor-not-allowed'
    } ${baseClass}
  `.trim();

  return (
    <div className={`flex items-center space-x-1 ${className}`}>
      {/* Undo */}
      <button
        type="button"
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => executeCommand('undo')}
        className={buttonClass()}
        disabled={!isActive}
        title="Undo"
      >
        ↶
      </button>

      {/* Redo */}
      <button
        type="button"
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => executeCommand('redo')}
        className={buttonClass()}
        disabled={!isActive}
        title="Redo"
      >
        ↷
      </button>

      {/* Separator */}
      <div className="w-px h-6 bg-gray-300 mx-1" />

      {/* Basic Formatting */}
      <button
        type="button"
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => executeCommand('bold')}
        className={buttonClass('font-bold')}
        disabled={!isActive}
        title="Bold"
      >
        B
      </button>
      
      <button
        type="button"
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => executeCommand('italic')}
        className={buttonClass('italic')}
        disabled={!isActive}
        title="Italic"
      >
        I
      </button>
      
      <button
        type="button"
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => executeCommand('underline')}
        className={buttonClass('underline')}
        disabled={!isActive}
        title="Underline"
      >
        U
      </button>

      {/* Separator */}
      <div className="w-px h-6 bg-gray-300 mx-1" />

      {/* Lists */}
      <button
        type="button"
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => executeCommand('insertUnorderedList')}
        className={buttonClass()}
        disabled={!isActive}
        title="Bullet List"
      >
        •
      </button>
      
      <button
        type="button"
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => executeCommand('insertOrderedList')}
        className={buttonClass()}
        disabled={!isActive}
        title="Numbered List"
      >
        1.
      </button>

      {/* Clear Formatting */}
      <button
        type="button"
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => executeCommand('removeFormat')}
        className={buttonClass()}
        disabled={!isActive}
        title="Clear Formatting"
      >
        ✕
      </button>

      {/* Separator */}
      <div className="w-px h-6 bg-gray-300 mx-1" />

      {/* Textbox Management */}
      <button
        type="button"
        onMouseDown={(e) => e.preventDefault()}
        onClick={onAddTextbox}
        className={`px-2 py-1 border rounded text-sm font-medium transition-colors duration-200 ${
          isActive 
            ? 'border-indigo-500 text-black hover:bg-indigo-50' 
            : 'border-gray-300 text-gray-400 cursor-not-allowed'
        }`}
        disabled={!isActive}
        title="Add Textbox Below"
      >
        🔳+
      </button>
      
      <button
        type="button"
        onMouseDown={(e) => e.preventDefault()}
        onClick={onDeleteTextbox}
        className={`px-2 py-1 border rounded text-sm font-medium transition-colors duration-200 ${
          isActive && canDeleteTextbox
            ? 'border-indigo-500 text-black hover:bg-indigo-50' 
            : 'border-gray-300 text-gray-400 cursor-not-allowed'
        }`}
        disabled={!isActive || !canDeleteTextbox}
        title={canDeleteTextbox ? "Delete This Textbox" : "Cannot delete default textbox"}
      >
        <span style={{ color: canDeleteTextbox && isActive ? '#dc2626' : 'inherit' }}>🔳-</span>
      </button>
      
      <button
        type="button"
        onMouseDown={(e) => e.preventDefault()}
        onClick={onAddPhotos}
        className={`px-2 py-1 border rounded text-sm font-medium transition-colors duration-200 ${
          isActive 
            ? 'border-indigo-500 text-black hover:bg-indigo-50' 
            : 'border-gray-300 text-gray-400 cursor-not-allowed'
        }`}
        disabled={!isActive}
        title="Add Photos After This Textbox"
      >
        📷
      </button>
    </div>
  );
};

export default SharedRichTextToolbar;